import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") {
      console.error("Uncaught render error:", error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div role="alert" style={{ padding: "3rem", textAlign: "center" }}>
          <h1>Something went wrong</h1>
          <p>The page failed to load. Try reloading, or head back to the homepage.</p>
          <button type="button" onClick={() => window.location.assign("/")}>
            Go to homepage
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
